import { Dialog, Box, IconButton, Typography, Divider, Switch, Button, UserAvatar, NotificationsOutlinedIcon,
    InfoOutlinedIcon, CloseIcon, CircularProgress
 } from "src/components";
import { useIsMobile, useSnackbar } from "src/hooks";
import { useAuth, getChatMembers } from "src/utils";
import { useEffect, useState } from "react";

export default function ChatInfoModal({ chatId, isAIChat, onClose }) {
  const isMobile = useIsMobile();
  const { openSnackbar } = useSnackbar();
  const { user } = useAuth();

  const [members, setMembers] = useState([]); 
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadChatMembers() {
      setLoading(true);
      try {
          const res = await getChatMembers(chatId);
          setMembers(res?.members);
          console.log(res?.members);
      } catch (err) {
          console.error("Error fetching chat members", err);
          openSnackbar('Could not fetch chat members', 'error');
      } finally {
        setLoading(false);
      }
    }

    if (!isAIChat) {
      loadChatMembers();
    } else {
      setMembers([
        {name: "PanAm Assistant"},
        {id: user?.id, name: user?.name, profileImageUrl: user?.profileImageUrl}
      ]);
    }
  }, [chatId, isAIChat]);

  return (
    <Dialog
      open
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          overflow: 'hidden',
          pt: isMobile ? 'var(--safe-area-top)' : 0,
          pb: isMobile ? 'var(--safe-area-bottom)' : 0,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflowY: "auto",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <InfoOutlinedIcon sx={{ color: "text.secondary" }} />
            <Typography variant="h5">Details</Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Notifications Toggle */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <NotificationsOutlinedIcon sx={{ color: "text.secondary" }} />
            <Typography variant="body1">Mute notifications</Typography>
          </Box>
          <Switch disabled size="small" />
        </Box>

        <Divider />

        {/* Members Section */}
        <Box className="scrollBox" sx={{ flex: 1, p: 2 }}>
          <Typography variant="h5" sx={{ mt: 1, mb: 2, fontWeight: 600 }}>
            Members
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {loading ? (
              <CircularProgress size={22} sx={{margin: 'auto'}} />
            ) : (<>
              {members.map((member) => (
                <Box
                  key={member.userId}
                  sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <UserAvatar
                      user={{
                        id: member.userId,
                        name: member.name,
                        profileImageUrl: member.profileImageUrl,
                      }}
                      size={32}
                    />
                  <Typography variant="body1"  fontWeight={500}>{member.name}</Typography>
                </Box>
              ))}
            </>)}
          </Box>
        </Box>

        {/* Bottom Actions */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            pb: 1,
            px: 2,
          }}
        >
          <Divider />

          <Button
            variant="text"
            color="warning"
            disabled
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              py: 1.5,
              "&:hover": {
                backgroundColor: "#efefef",
              },
            }}
          >
            Report Chat
          </Button>
          <Button
            variant="text"
            color="warning"
            disabled
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              py: 1.5,
              "&:hover": {
                backgroundColor: "#efefef"
              },
            }}
          >
            Block User
          </Button>
          <Button
            variant="text"
            color="warning"
            disabled
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              py: 1.5,
              "&:hover": {
                backgroundColor: "#efefef",
              },
            }}
          >
            Delete Chat
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
